export default __webpack_public_path__ + "static/closing-dd810b7ce61cf85301e307a0c3ac2b67.jpeg";